import draft from './Ph1/draft'
import pendingReview from './Ph1/pendingReview'
import inReview from './Ph1/inReview'
import reviewed from './Ph1/reviewed'
import waitingDeveloperPublish from './Ph1/waitingDeveloperPublish'
import published from './Ph1/published'
import preOrder from './Ph1/preOrder'
import removed from './Ph1/removed'
import rejected from './Ph1/rejected'
import unpublished from './Ph1/unpublished'
import developerRejected from './Ph1/developerRejected'

export default {
    draft,
    pendingReview,
    inReview,
    reviewed,
    waitingDeveloperPublish,
    published,
    preOrder,
    removed,
    rejected,
    unpublished,
    developerRejected
}
